Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _range = require('lodash/range');

var _range2 = _interopRequireDefault(_range);

var _withStyles = require('../themes/withStyles');

var _size = require('../size');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MIN_COLUMNS = 1;
var MAX_COLUMNS = 12;
var COLUMNS_RANGE = (0, _range2['default'])(MIN_COLUMNS, MAX_COLUMNS + 1);
var COLUMNS_RANGE_PROPTYPE = _propTypes2['default'].oneOf(COLUMNS_RANGE);

var MIN_OFFSET = 0;
var MAX_OFFSET = MAX_COLUMNS - 1;
var OFFSET_RANGE = (0, _range2['default'])(MIN_OFFSET, MAX_OFFSET + 1);
var OFFSET_RANGE_PROPTYPE = _propTypes2['default'].oneOf(OFFSET_RANGE);

var PULL_OPTIONS = ['left', 'right'];

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: _propTypes2['default'].node,
  condensed: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('condensed', 'largeGutter'),
  largeGutter: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('condensed', 'largeGutter'),
  sm: COLUMNS_RANGE_PROPTYPE,
  md: COLUMNS_RANGE_PROPTYPE,
  lg: COLUMNS_RANGE_PROPTYPE,
  smOffset: OFFSET_RANGE_PROPTYPE,
  mdOffset: OFFSET_RANGE_PROPTYPE,
  lgOffset: OFFSET_RANGE_PROPTYPE,
  pull: _propTypes2['default'].oneOf(PULL_OPTIONS)
}));

var defaultProps = {
  condensed: false,
  largeGutter: false,
  pull: 'left'
};

function getColumnStyleName(breakpoint, size) {
  return 'column-' + String(breakpoint) + '-' + String(size);
}

function getOffsetStyleName(breakpoint, size, pull) {
  return 'offset-' + String(breakpoint) + '-' + String(size) + '-' + String(pull);
}

function Column(_ref) {
  var css = _ref.css,
      children = _ref.children,
      condensed = _ref.condensed,
      largeGutter = _ref.largeGutter,
      lg = _ref.lg,
      lgOffset = _ref.lgOffset,
      md = _ref.md,
      mdOffset = _ref.mdOffset,
      pull = _ref.pull,
      sm = _ref.sm,
      smOffset = _ref.smOffset,
      styles = _ref.styles;

  return _react2['default'].createElement(
    'div',
    css(styles.column, condensed && styles.column_condensed, largeGutter && styles.column_largeGutter, sm && styles[getColumnStyleName('sm', sm)], md && styles[getColumnStyleName('md', md)], lg && styles[getColumnStyleName('lg', lg)], smOffset && styles[getOffsetStyleName('sm', smOffset, pull)], mdOffset && styles[getOffsetStyleName('md', mdOffset, pull)], lgOffset && styles[getOffsetStyleName('lg', lgOffset, pull)], pull === 'right' && styles.pullRight),
    children
  );
}

Column.componentCategory = 'Core';
Column.displayName = 'Column';
Column.propTypes = propTypes;
Column.defaultProps = defaultProps;

var columnStyles = function () {
  var style = {};

  COLUMNS_RANGE.forEach(function (i) {
    var widthPercent = i / MAX_COLUMNS * 100 + '%';

    style[getColumnStyleName('sm', i)] = {
      width: widthPercent,
      float: 'left'
    };

    style[getColumnStyleName('md', i)] = _defineProperty({}, _size.responsive.mediumAndAbove, {
      width: widthPercent,
      float: 'left'
    });

    style[getColumnStyleName('lg', i)] = _defineProperty({}, _size.responsive.largeAndAbove, {
      width: widthPercent,
      float: 'left'
    });
  });

  OFFSET_RANGE.forEach(function (i) {
    PULL_OPTIONS.forEach(function (j) {
      var property = j === 'right' ? 'marginRight' : 'marginLeft';
      var widthPercent = i / MAX_COLUMNS * 100 + '%';

      style[getOffsetStyleName('sm', i, j)] = _defineProperty({}, property, widthPercent);

      style[getOffsetStyleName('md', i, j)] = _defineProperty({}, _size.responsive.mediumAndAbove, _defineProperty({}, property, widthPercent));

      style[getOffsetStyleName('lg', i, j)] = _defineProperty({}, _size.responsive.largeAndAbove, _defineProperty({}, property, widthPercent));
    });
  });

  return style;
}();

exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
  var _pullRight;

  var unit = _ref2.unit;
  return Object.assign({}, columnStyles, {

    column: {
      paddingLeft: unit,
      paddingRight: unit,
      minHeight: 1,
      position: 'relative'
    },

    column_largeGutter: {
      paddingLeft: 1.5 * unit,
      paddingRight: 1.5 * unit
    },

    column_condensed: {
      paddingLeft: 0.5 * unit,
      paddingRight: 0.5 * unit
    },

    pullRight: (_pullRight = {
      float: 'right'
    }, _defineProperty(_pullRight, _size.responsive.mediumAndAbove, {
      float: 'right'
    }), _defineProperty(_pullRight, _size.responsive.largeAndAbove, {
      float: 'right'
    }), _pullRight)
  });
})(Column);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Column.js
// module id = 23
// module chunks = 168707334958949